import PasswordField from '@Components/Form/PasswordField/PasswordField'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { CommonService } from '@Services/common.service'
import { FormService } from '@Services/form.service'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import * as Redux from 'redux'
import AuthAction from '../../../store/auth/auth.action'
import AuthLayout from '../AuthLayout'

const defaultValues = {
    confirmPassword: '',
    password: '',
    answer1: '',
    answer2: '',
    answer3: '',
    username: '',
}

interface IRegister {
    // redux
    getAuthorization: () => Promise<any>
    getPublicToken: () => Promise<any>
    validationUsername: (username: string) => Promise<any>
    setRegister: (registerData: any) => void
    register: any
    user?: any
}

const Register = (props: IRegister) => {
    // core section
    const {
        getAuthorization,
        getPublicToken,
        validationUsername,
        setRegister,
        register,
        user,
    } = props
    const history = useHistory()
    const ac = new AbortController()
    const {
        control,
        handleSubmit,
        watch,
        formState: { errors, dirtyFields, submitCount },
        reset,
    } = useForm({ defaultValues })
    const watchPassword = watch('password')
    const classesInput = 'reddit-input material-input-width mb-2'
    const passwordPattern =
        // eslint-disable-next-line no-useless-escape
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
    const passwordHint = `Password at least contain 
                          one upper case, 
                          one lower case, 
                          one digit and one special character`

    // states section
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        if (!register?.security) return
        reset({ ...register?.security })
        return () => {
            ac.abort()
        }
    }, [register])

    useEffect(() => {
        if (user?.role) {
            history.push('/firearms')
        }
        return () => {
            ac.abort()
        }
    }, [user])

    // functions section
    const onSubmit = (formData: any) => {
        setDisabled(true)
        const newData = { ...register, security: formData }
        const username = formData?.username
        getAuthorization()
            .then(() => {
                validationUsername(username)
                    .then(() => {
                        getPublicToken()
                        setRegister(newData)
                        history.push('/create-profile-step-1')
                    })
                    .catch(() => setDisabled(false))
            })
            .catch(() => setDisabled(false))
    }

    // main section
    return (
        <AuthLayout>
            <div className="auth-bg login-form">
                <p className="auth-headline">REGISTER</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        control={control}
                        name="username"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="User Name"
                                variant="filled"
                                className={classesInput}
                                error={errors?.username && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'username',
                                    'Username'
                                )}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'spacial',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="password"
                        defaultValue=""
                        rules={{
                            required: true,
                            minLength: 8,
                            pattern: passwordPattern,
                        }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <PasswordField
                                {...field}
                                value={value}
                                onChange={onChange}
                                type="password"
                                inputRef={ref}
                                label="Password"
                                variant="filled"
                                className={classesInput}
                                error={errors?.password && true}
                                helperText={
                                    (+submitCount > 0 &&
                                        dirtyFields?.password) ||
                                    register?.security?.password
                                        ? FormService.getErrorMessage(
                                              errors,
                                              'password',
                                              'Password',
                                              errors?.password?.type ===
                                                  'pattern'
                                                  ? `Password at least contain 
                                        one upper case, 
                                        one lower case, 
                                        one digit and one special character`
                                                  : 'Password should contain 8 characters'
                                          )
                                        : passwordHint
                                }
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'spacial',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="confirmPassword"
                        defaultValue=""
                        rules={{
                            required: true,
                            validate: (value) => value === watchPassword,
                            minLength: 8,
                        }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <PasswordField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                type="password"
                                label="Confirm Password"
                                variant="filled"
                                className={classesInput}
                                error={errors?.confirmPassword && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'confirmPassword',
                                    'Confirm Password',
                                    // eslint-disable-next-line max-len
                                    // eslint-disable-next-line no-nested-ternary
                                    errors?.confirmPassword?.type === 'pattern'
                                        ? `Password at least contain 
                                        one upper case, 
                                        one lower case, 
                                        one digit and one special character`
                                        : errors?.confirmPassword?.type ===
                                          'validate'
                                        ? 'Passwords do not match'
                                        : 'Password should contain 8 characters'
                                )}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'numeric',
                                        'spacial',
                                    ])
                                }
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="answer1"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value || ''}
                                onChange={onChange}
                                inputRef={ref}
                                label="What is the name of your favorite pet?"
                                variant="filled"
                                className={classesInput}
                                error={errors?.answer1 && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'answer1',
                                    'Security Question #1'
                                )}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'numeric',
                                        'space',
                                    ])
                                }
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="answer2"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value || ''}
                                onChange={onChange}
                                inputRef={ref}
                                label="What high school did you attend?"
                                variant="filled"
                                className={classesInput}
                                error={errors?.answer2 && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'answer2',
                                    'Security Question #2'
                                )}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'space',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="answer3"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value || ''}
                                onChange={onChange}
                                inputRef={ref}
                                label="What was your favorite food as a child?"
                                variant="filled"
                                className={classesInput}
                                error={errors?.answer3 && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'answer3',
                                    'Security Question #3'
                                )}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'space',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />

                    <button
                        type="submit"
                        className="auth-primary-btn"
                        disabled={disabled}
                    >
                        Next
                    </button>
                </form>

                <Link to="/login" className="login-instead-link d-block mt-4">
                    Log in Instead
                </Link>
            </div>
        </AuthLayout>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const { register, user } = state?.auth

    return {
        register,
        user,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const {
        setRegister,
        validationUsername,
        getAuthorization,
        getPublicToken,
    } = AuthAction
    return {
        setRegister: (registerData: any) =>
            dispatch(setRegister(registerData) as any),
        validationUsername: (username: string) =>
            dispatch(validationUsername(username) as any),
        getAuthorization: () => dispatch(getAuthorization() as any),
        getPublicToken: () => dispatch(getPublicToken() as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
